export class CartExpired extends Error {
  constructor(...params) {
    super(...params)
    this.name = "CartExpiredError";
    this.message = "Cart has expired and is no longer retrievable.";
  }
}
